const doc = [({"en":({"adminConstantListTypes":({"planList":"View by Plan List", "roomList":"View by Room List"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;